import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import moment from "moment";

import {LeadFilterDataAPI, CallerAPI, BulkLeadAssignCallerAPI} from "./../../../API/Team/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
//import { data } from "jquery";
import { ToastContainer } from 'react-toastify';
import { errorMesg } from "../../Toaster";


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [callers, setCallers] = useState([]);
    const [callername, setCallerName] = useState("");
    const [leadids, setLeadIDs] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);

    const perpagedata = 20;

    const filterparams = new URLSearchParams();
    

    useEffect(() => {

        CallerAPI(setCallers);
    }, []);

    useEffect(() => {

        console.log('search params====' + searchParam);        

        if(searchParam !== "" && searchParam !== null)
        {
            if(searchParam.get('filter_campaignid') !== "" && searchParam.get('filter_campaignid') !== null)
            {
                filterparams.append('filter_campaignid', searchParam.get('filter_campaignid'));
            }

            if(searchParam.get('filter_callerid') !== "" && searchParam.get('filter_callerid') !== null)
            {
                filterparams.append('filter_callerid', searchParam.get('filter_callerid'));
            }

            if(searchParam.get('filter_startdate') !== "" && searchParam.get('filter_startdate') !== null)
            {
                filterparams.append('filter_startdate', searchParam.get('filter_startdate'));
            }

            if(searchParam.get('filter_enddate') !== "" && searchParam.get('filter_enddate') !== null)
            {
                filterparams.append('filter_enddate', searchParam.get('filter_enddate'));
            }

            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }

            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
        }

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, setIsLeadAssign, filterparams);

        CallerAPI(setCallers);
        
        setLeadIDs([]);

    }, [currentPage, isleadassign]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }

    const handleCallerName = (e) =>{
        setCallerName(e.target.value);
    }

    const handleLeadAssign = (e) =>{
        

        if(callername !== "" && callername !== null && callername !== undefined)
        {
            if(leadids.length > 0)
            {
                console.log('caller id===' + callername);    
                console.log('selected ids===' + leadids);    

                const params = {
                                'callerid': callername,
                                'leadids': leadids
                            };
                            
                BulkLeadAssignCallerAPI(params, setIsLeadAssign);
            }
            else
            {
                errorMesg('Please select a lead to assign this caller');
                return;    
            }
        }
        else
        {
            errorMesg('Please select a caller');
            return;
        }
    }

    const handleSelectLead = (lid) =>{
        if(leadids.includes(lid))
        {
            setLeadIDs(leadids.filter(item => item !== lid));
        }
        else
        {
            setLeadIDs([...leadids, lid]);
        }
    }

    const handleSelectAllLeads = () =>{

        if(leadids.length === leads.length)
        {
            setLeadIDs([]);
        }
        else
        {
            setLeadIDs(leads.map(item => item.id));
        }
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    {filtertype === 'freshlead' ?
                                        <h4 className="page-title">Fresh Leads</h4>
                                    :
                                        (filtertype === 'warmleads' ?
                                            <h4 className="page-title">Warm Leads</h4>
                                        :
                                            (filtertype === 'contactedleads' ?
                                                <h4 className="page-title">Contacted Leads</h4>
                                            :
                                                (filtertype === 'deadleads' ?
                                                    <h4 className="page-title">Dead Leads</h4>
                                                :
                                                    (filtertype === 'coldleads' ?
                                                        <h4 className="page-title">Cold Leads</h4>
                                                    :
                                                        (filtertype === 'attemptleads' ?
                                                            <h4 className="page-title">Attempt to Contact Leads</h4>
                                                        :
                                                            (filtertype === 'enrolledleads' ?
                                                                <h4 className="page-title">Enrolled Leads</h4>
                                                            :
                                                                (filtertype === 'totalleads' ?
                                                                    <h4 className="page-title">Total Leads</h4>
                                                                :
                                                                    <></>    
                                                                )   
                                                            )   
                                                        )   
                                                    )   
                                                )
                                            )
                                        )
                                    }
                                </div>
                                <div className="col-4 text-end">
                                    <div className="d-flex justify-content-end">
                                        <select className="form-select me-2" name="caller" onChange={handleCallerName }>
                                            <option value="">Select Caller</option>
                                            {callers.map((caller) =>
                                                (
                                                    <option key={caller.id} value={caller.id}>{caller.name}</option>
                                                    
                                                ))                                        
                                            }
                                        </select>

                                        <button type="button" className="btn btn-primary"  onClick={handleLeadAssign}>
                                            {btnloader ?
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            :
                                                <p>Assign Lead</p>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">
                                                            
                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked={leadids.length > 0 && leadids.length === leads.length} onChange={handleSelectAllLeads} />
                                                        <label class="form-check-label" for="flexCheckDefault"></label>
                                                    </div>
                                                </th>
                                                
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>
                                                <th>Location</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Lead Status</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="9">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (leads && leads.length > 0  ? 
                                                ( leads.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>
                                                            <td>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="checkbox" id={'chkleaddata'+lead.id} checked={leadids.includes(lead.id)} onChange={() => handleSelectLead(lead.id)} />
                                                                    <label class="form-check-label" for={'chkleaddata'+lead.id}></label>
                                                                </div>

                                                                <Link to={`/team/lead-profile/${lead.id}`} className="">
                                                                    <i className="fa fa-pencil"></i>
                                                                </Link>
                                                            </td>
                                                            
                                                            
                                                            <td>{lead.name}</td>
                                                            <td>{lead.email}</td>
                                                            <td>{lead.contact}</td>
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>
                                                            <td>{lead.institute}</td>
                                                            <td>
                                                                {lead.subdispositionname !== "" && lead.subdispositionname !== null ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.subdispositionname}</span>
                                                                :
                                                                    (lead.dispositionname !== "" && lead.dispositionname !== null ?
																<span class="badge badge-tag badge-purple-light">{lead.dispositionname}</span>
                                                                    :
                                                                        (lead.stagename !== "" && lead.stagename !== null ?
                                                                            <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                                        :
                                                                            <></>   
                                                                        )
                                                                    )
                                                                }
                                                            </td>
                                                            <td>{moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="9">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="pagination-section mt-3">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default LeadFilter;